import React from 'react';
import { Fragment } from 'react';

const getViewBox = (name) => {
    switch (name) {
        case 'BBM':
        case 'LiveChat':
        case 'Phone':
        case 'Skype':
        case 'Telegram':
        case 'Viber':
        case 'WeChat':
        case 'WhatsApp':
        case 'Yahoo':
        case 'Zalo':
        case 'Email':
        case 'Line':
        case 'Twitter':
            return '0 0 80 80';
        case 'register-telegram':
            return '0 0 533.7627 533.76318';
        default:
            return '0 0 40 40';
    }
};

const getPath = (name, props) => {
    switch (name) {
        case 'BBM':
            return (
                <path
                    {...props}
                    style={{ fill: '#A2AABD' }}
                    d='M40,5C20.7,5,5,20.7,5,40c0,19.3,15.7,35,35,35c19.3,0,35-15.7,35-35C75,20.7,59.3,5,40,5z M23.2,44.7 c-3.2,0-6.7,0-6.7,0l1.8-8.5c0,0,4.7,0,6.4,0c4.2,0,5.2,2,5.2,3.7C29.9,42.3,28.4,44.7,23.2,44.7z M25.5,32c-3.2,0-6.7,0-6.7,0 l1.8-8.5c0,0,4.7,0,6.4,0c4.2,0,5.2,2.1,5.2,3.7C32.2,29.5,30.7,32,25.5,32z M38.6,58c-3.2,0-6.7,0-6.7,0l1.8-8.5c0,0,4.7,0,6.4,0 c4.2,0,5.2,2.1,5.2,3.7C45.3,55.5,43.8,58,38.6,58z M41.1,44.7c-3.2,0-6.7,0-6.7,0l1.8-8.5c0,0,4.7,0,6.4,0c4.2,0,5.2,2,5.2,3.7 C47.8,42.3,46.3,44.7,41.1,44.7z M43.4,32c-3.2,0-6.7,0-6.7,0l1.8-8.5c0,0,4.7,0,6.4,0c4.2,0,5.2,2.1,5.2,3.7 C50.2,29.5,48.7,32,43.4,32z M56.5,51.6c-3.2,0-6.7,0-6.7,0l1.8-8.5c0,0,4.7,0,6.4,0c4.2,0,5.2,2.1,5.2,3.7 C63.3,49.1,61.8,51.6,56.5,51.6z M59,39.6c-3.2,0-6.7,0-6.7,0l1.8-8.5c0,0,4.7,0,6.4,0c4.2,0,5.2,2.1,5.2,3.7 C65.8,37.1,64.3,39.6,59,39.6z'
                />
            );

        case 'LiveChat':
            return (
                <Fragment>
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M40,5C20.7,5,5,20.7,5,40s15.7,35,35,35s35-15.7,35-35S59.3,5,40,5z M40,62.4c-2.4,0-4.7-0.4-6.8-1.1l-9.6,4.6 l2-8.8c-4.9-4.1-8-10.3-8-17.1c0-12.4,10-22.4,22.4-22.4s22.4,10,22.4,22.4C62.4,52.4,52.4,62.4,40,62.4z'
                    />
                    <g>
                        <path
                            {...props}
                            style={{ fill: '#A2AABD', fillRule: 'evenodd', clipRule: 'evenodd' }}
                            d='M49.8,34.5H30c-0.7,0-1.2-0.6-1.2-1.2v0c0-0.7,0.6-1.2,1.2-1.2h19.8c0.7,0,1.2,0.6,1.2,1.2v0 C51,34,50.5,34.5,49.8,34.5z'
                        />
                        <path
                            {...props}
                            style={{ fill: '#A2AABD', fillRule: 'evenodd', clipRule: 'evenodd' }}
                            d='M49.8,41.6H30c-0.7,0-1.2-0.6-1.2-1.2v0c0-0.7,0.6-1.2,1.2-1.2h19.8c0.7,0,1.2,0.6,1.2,1.2v0 C51,41.1,50.5,41.6,49.8,41.6z'
                        />
                        <path
                            {...props}
                            style={{ fill: '#A2AABD', fillRule: 'evenodd', clipRule: 'evenodd' }}
                            d='M49.8,48.7H30c-0.7,0-1.2-0.6-1.2-1.2l0,0c0-0.7,0.6-1.2,1.2-1.2h19.8c0.7,0,1.2,0.6,1.2,1.2l0,0 C51,48.2,50.5,48.7,49.8,48.7z'
                        />
                    </g>
                </Fragment>
            );

        case 'Phone':
            return (
                <g>
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M42.2,42c-5.3-1.8-10.4,3.2-8.8,8.5c0.7,2.2,2.5,4,4.8,4.6c5.1,1.3,9.6-3.1,8.4-8.2 C46.1,44.7,44.4,42.8,42.2,42z'
                    />
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M40,5C20.7,5,5,20.7,5,40c0,19.3,15.7,35,35,35c19.3,0,35-15.7,35-35C75,20.7,59.3,5,40,5z M58.9,59.8 c-12.8,0-25.6,0-38.5,0c-2.3,0-3.1-0.5-3.8-2.7c-2.3-7.7,1.8-18.9,10.7-20.5c3.2-0.6,4.3-2.9,4.6-5.8c0.3-2.7,1-3.2,3.5-3.6 c1.5-0.3,2.1,0.4,2.2,1.7c0,0.3,0,0.6,0,0.9c-0.1,2.4,0.7,3.1,3.1,2.9c1.1-0.1,1.8-0.6,1.8-1.8c0-0.6,0-1.2,0-1.8 c0-0.6,0.1-1.2,0.1-2c1.2,0.2,2.2,0.3,3.2,0.5c1.3,0.3,2.1,1.1,2.2,2.6c0.4,4.3,1.7,6.1,5.8,7c3.6,0.8,5.8,2.9,7.3,6 c1.8,3.6,2.9,7.4,2.9,11.5C64.1,58.5,62.6,59.8,58.9,59.8z M63.3,34.2c-1.4,2.6-3.5,3.2-6.1,1.8c-1.8-1-3.7-2-5.5-3 c-2.3-1.3-2.9-2.5-2.4-5.1c0.3-1.2,0.1-1.7-1.1-2.1c-5.6-1.9-11.2-1.3-16.7,0.4c-0.4,0.1-0.7,0.9-0.7,1.3c-0.1,2.6-1.2,4.4-3.5,5.6 c-1.9,1-3.8,2.2-5.8,3.3c-2.8,1.5-4.8,0.7-5.8-2.3c-1.5-4.6-0.2-8.3,3.3-11.4c4.6-4.2,10.3-5.9,16.3-6.6c1.9-0.2,3.8-0.3,5-0.4 c5.6,0.1,10.4,0.5,14.9,2.5c2.2,1,4.4,2.3,6.2,3.9C65.1,25.2,65.7,29.9,63.3,34.2z'
                    />
                </g>
            );

        case 'Skype':
            return (
                <g>
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M40,5C20.7,5,5,20.7,5,40s15.7,35,35,35s35-15.7,35-35S59.3,5,40,5z M58.8,58.7c-2.4,2.4-5.5,3.7-8.9,3.7 c-2.2,0-4.3-0.6-6.2-1.6c-1.2,0.2-2.5,0.3-3.7,0.3c-2.9,0-5.6-0.6-8.3-1.7c-2.5-1.1-4.8-2.6-6.7-4.5c-1.9-1.9-3.5-4.2-4.5-6.7 c-1.1-2.6-1.7-5.4-1.7-8.3c0-1.2,0.1-2.5,0.3-3.7c-1-1.9-1.6-4-1.6-6.1c0-3.4,1.3-6.5,3.7-8.9c2.4-2.4,5.5-3.7,8.9-3.7 c2.1,0,4.1,0.5,5.9,1.5c0,0,0,0,0,0c1.3-0.3,2.7-0.4,4-0.4c2.9,0,5.6,0.6,8.3,1.7c2.5,1.1,4.8,2.6,6.7,4.5c1.9,1.9,3.5,4.2,4.5,6.7 c1.1,2.6,1.7,5.4,1.7,8.3c0,1.3-0.1,2.6-0.4,3.8c1,1.9,1.6,4,1.6,6.1C62.5,53.2,61.2,56.4,58.8,58.7z'
                    />
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M44,37.4l-5-1.1c-1.9-0.4-4.1-1-4.1-2.8c0-1.8,1.5-3,4.3-3c5.5,0,5,3.8,7.8,3.8c1.4,0,2.7-0.9,2.7-2.3 c0-3.4-5.5-6-10.1-6c-5,0-10.4,2.1-10.4,7.8c0,2.7,1,5.7,6.4,7l6.7,1.7c2,0.5,2.5,1.6,2.5,2.7c0,1.7-1.7,3.4-4.8,3.4 c-6,0-5.2-4.6-8.4-4.6c-1.4,0-2.5,1-2.5,2.4c0,2.8,3.4,6.5,10.9,6.5c7.2,0,10.7-3.5,10.7-8.1C50.8,41.8,49.4,38.6,44,37.4z'
                    />
                </g>
            );

        case 'Telegram':
            return (
                <g>
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M52.4,29.3c-0.2,0.1-0.4,0.2-0.6,0.3c-7.4,4.7-14.9,9.3-22.3,14c-0.2,0.1-0.3,0.3-0.2,0.5 c0.8,2.4,1.6,4.8,2.4,7.2c0.4,1.3,0.9,2.6,1.3,4c0.1-0.5,0.1-0.9,0.2-1.3c0.3-2.2,0.5-4.5,0.8-6.7c0-0.2,0.1-0.4,0.3-0.5 c1-0.9,2-1.8,3-2.7c5.2-4.6,10.3-9.3,15.5-13.9c0.1-0.1,0.3-0.3,0.3-0.4c0-0.1,0-0.4-0.1-0.5C52.7,29.3,52.5,29.3,52.4,29.3z'
                    />
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M40,5C20.7,5,5,20.7,5,40s15.7,35,35,35s35-15.7,35-35S59.3,5,40,5z M60.3,27.4c-0.9,4.3-1.8,8.6-2.6,12.9 c-1,5.1-2.1,10.2-3.1,15.3c-0.2,0.8-0.3,1.6-0.5,2.4c0,0.1,0,0.2-0.1,0.3c-0.6,2.3-2.3,2.5-3.9,1.3c-2.7-1.9-5.3-3.9-8-5.9 c-0.7-0.5-1.3-1-2-1.5c-0.2-0.2-0.4-0.2-0.6,0c-1.5,1.5-3.1,3-4.6,4.5c-0.3,0.3-0.7,0.6-1.1,0.9c-0.9,0.6-1.9,0.4-2.3-0.6 c-0.3-0.7-0.6-1.4-0.8-2.1c-1.1-3.4-2.2-6.7-3.3-10.1c-0.1-0.3-0.3-0.5-0.6-0.6c-3.1-1-6.2-1.9-9.4-2.9c-0.2-0.1-0.3-0.1-0.5-0.2 c-1-0.5-1.3-1.7-0.5-2.5c0.3-0.3,0.7-0.5,1-0.7c8.7-3.3,17.4-6.6,26.1-9.9c4.6-1.7,9.2-3.5,13.8-5.2c0.5-0.2,1-0.4,1.5-0.4 c1.1-0.1,1.8,0.6,1.8,1.7c0,0.1,0,0.2,0,0.3c0,0,0,0,0.1,0C60.7,25.6,60.5,26.5,60.3,27.4z'
                    />
                </g>
            );

        case 'Viber':
            return (
                <g>
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M56.7,21c-1.1-1-5.9-4.1-15.9-4.2c0,0-11.8-0.8-17.6,4.5c-3.2,3.2-4.3,8-4.4,13.9c-0.1,5.9-0.5,17.1,10,20 l0.1,0l0,10l7.8-8.7c7.2,0.5,12.9-1,13.6-1.2c1.4-0.5,9.3-1.2,10.6-12.2C62.3,31.9,60.4,24.2,56.7,21z M39.6,24.2L39.6,24.2 c3.5,0,6.4,1.2,8.7,3.5c1.2,1.2,2.1,2.6,2.6,4.2c0.6,1.6,0.9,3.4,0.9,5.4c0,0.2-0.1,0.3-0.3,0.3h0c-0.2,0-0.3-0.1-0.3-0.3 c0-1.9-0.3-3.7-0.9-5.2c-0.6-1.5-1.4-2.8-2.5-3.9c-1.1-1.1-2.4-1.9-3.7-2.5c-1.4-0.6-2.9-0.8-4.6-0.9c-0.2,0-0.3-0.1-0.3-0.3 C39.3,24.4,39.5,24.2,39.6,24.2z M43.8,28.9c-0.9-0.4-2-0.7-3.2-0.7c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3 c2.5,0.2,4.5,1.1,5.9,2.7c1.4,1.6,2.1,3.6,2.1,5.9c0,0.2-0.1,0.3-0.3,0.3h0c-0.2,0-0.3-0.2-0.3-0.3c0-2.2-0.6-4-1.9-5.5 C45.5,29.8,44.7,29.3,43.8,28.9z M45.6,35c0,0.2-0.1,0.3-0.3,0.3h0c-0.2,0-0.3-0.1-0.3-0.3c-0.1-1.1-0.4-2-0.9-2.6 c-0.5-0.6-1.4-0.9-2.4-1c-0.2,0-0.3-0.2-0.3-0.3c0-0.2,0.2-0.3,0.3-0.3c1.2,0.1,2.2,0.5,2.9,1.2C45.2,32.7,45.5,33.7,45.6,35z M52.3,47.5L52.3,47.5c-0.5,1-1.2,1.9-2.1,2.7l0,0c-1.2,1-2.3,1.3-3.4,0.9c-4.2-1.7-8.5-4.2-12.5-8.3c-4-4.2-6.7-8.8-8.1-13.2 L26,29.1c-0.3-1.6,0.7-2.7,3.5-4.5l0,0c1-0.6,1.9-0.3,2.5,0.2c0.6,0.4,2.2,2.5,2.2,2.5c0.3,0.5,2.5,3.2,2,4.5 c-0.2,0.7-1.5,1.5-2.1,2.2l-0.1,0c-0.3,0.5-0.4,0.8-0.3,1.5l0,0.1c0.4,1.7,1.4,3.4,3,5c1.6,1.6,3.3,2.5,4.8,2.9 c0.2,0,1,0.2,1.5-0.5l1-1.3c0.5-0.7,1.7-1.1,2.9-0.4c0.7,0.4,1.8,1.1,2.5,1.7c0.8,0.6,2.4,1.9,2.4,1.9 C52.6,45.6,52.8,46.5,52.3,47.5z'
                    />
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M40,5C20.7,5,5,20.7,5,40s15.7,35,35,35s35-15.7,35-35S59.3,5,40,5z M64.6,44.3c-1.6,13.2-11.3,14.4-13,15 c-0.7,0.2-7.3,1.9-15.8,1.2c-0.9,1.1-2.2,2.6-3.1,3.6c-1.6,1.8-2.6,3.5-4.4,2.9C27,66.5,27,64.3,27,64.3l0-5.5l0,0 C14.6,55.3,14.8,42.1,15,35.1c0.1-7,1.5-12.7,5.3-16.6C27,12.1,41,13,41,13c11.8,0.1,17.1,4,18.5,5.2 C63.8,22.1,66.2,30.7,64.6,44.3z'
                    />
                </g>
            );

        case 'WeChat':
            return (
                <g>
                    <path {...props} style={{ fill: '#A2AABD' }} d='M39.6,32.5c1.2,0,2.1-1,2.1-2.2c0-1.2-1-2.1-2.2-2.1c-1.2,0-2.2,1-2.2,2.2C37.4,31.6,38.3,32.5,39.6,32.5z' />
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M25.8,28.2c-1.2,0-2.2,0.9-2.2,2.1c0,1.2,0.9,2.2,2.1,2.2c1.2,0,2.2-0.9,2.3-2.1C28,29.3,27,28.2,25.8,28.2z'
                    />
                    <path {...props} style={{ fill: '#A2AABD' }} d='M43.6,42c-1,0-1.8,0.9-1.8,1.9c0,1,0.8,1.7,1.8,1.7c1,0,1.8-0.8,1.8-1.7C45.4,42.8,44.6,42,43.6,42z' />
                    <path {...props} style={{ fill: '#A2AABD' }} d='M54.7,42c-0.9,0-1.7,0.8-1.8,1.7c0,1,0.7,1.8,1.8,1.9c1,0,1.7-0.7,1.8-1.7C56.5,42.8,55.7,42,54.7,42z' />
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M40,5C20.7,5,5,20.7,5,40c0,19.3,15.7,35,35,35c19.3,0,35-15.7,35-35C75,20.7,59.3,5,40,5z M27.8,49.2 c-0.6-0.1-1.3,0-1.8,0.3c-1.7,0.9-3.3,2-5.2,3.2c0.3-1.6,0.6-3,1-4.3c0.3-1,0.2-1.5-0.7-2.2c-5.8-4.1-8.2-10.2-6.4-16.4 c1.7-5.8,5.8-9.3,11.4-11.2c7.7-2.5,16.3,0.1,20.9,6.1c1.7,2.2,2.7,4.7,3,7.6c-4.8,0.3-9,1.7-12.4,5c-3.4,3.3-5,7.4-4.6,12.4 C31.3,49.6,29.6,49.3,27.8,49.2z M61.6,57.1c-1.5,1.3-2,2.4-1.1,4.1c0.2,0.3,0.2,0.7,0.3,1.1c-1.5-0.7-2.9-1.7-4.4-1.8 c-1.5-0.2-3,0.7-4.6,0.9c-4.7,0.5-8.9-0.8-12.4-4.1c-6.6-6.1-5.7-15.5,2-20.5c6.8-4.5,16.8-3,21.6,3.2 C67.2,45.3,66.8,52.5,61.6,57.1z'
                    />
                </g>
            );

        case 'WhatsApp':
            return (
                <g>
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M55.4,44.1c-0.7-0.4-4.3-2.1-4.9-2.3c-0.7-0.2-1.1-0.4-1.6,0.4c-0.5,0.7-1.9,2.3-2.3,2.8 c-0.4,0.5-0.8,0.5-1.6,0.2c-0.7-0.4-3.1-1.1-5.8-3.6c-2.1-1.9-3.6-4.3-4-5c-0.4-0.7,0-1.1,0.3-1.5c0.3-0.3,0.7-0.8,1.1-1.3 c0.4-0.4,0.5-0.7,0.7-1.2c0.2-0.5,0.1-0.9-0.1-1.3C37,31,35.5,27.5,34.9,26c-0.6-1.4-1.2-1.4-1.6-1.4c-0.4,0-1.2,0.1-1.2,0.1 S30.6,25,30,25.7c-0.7,0.7-2.5,2.5-2.5,6c0,3.5,2.6,7,3,7.4c0.4,0.5,5,8,12.4,10.8c7.4,2.9,7.4,1.9,8.7,1.8 c1.3-0.1,4.3-1.7,4.9-3.4c0.6-1.7,0.6-3.1,0.4-3.4C56.6,44.6,56.1,44.4,55.4,44.1z'
                    />
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M40,5C20.7,5,5,20.7,5,40c0,19.3,15.7,35,35,35c19.3,0,35-15.7,35-35C75,20.7,59.3,5,40,5z M41.8,62.8 c-5,0-9.7-1.5-13.7-4.1l-9.5,3l3.1-9.1c-3-4.1-4.7-9.1-4.7-14.4c0-13.6,11.1-24.6,24.8-24.6c13.7,0,24.8,11.1,24.8,24.6 C66.7,51.7,55.5,62.8,41.8,62.8z'
                    />
                </g>
            );

        case 'Yahoo':
            return (
                <path
                    {...props}
                    style={{ fill: '#A2AABD' }}
                    d='M40,5C20.7,5,5,20.7,5,40s15.7,35,35,35s35-15.7,35-35S59.3,5,40,5z M54.7,32.5c-0.1,0-0.2,0.1-0.3,0.1 c-3.1,2.8-6.2,5.6-9.3,8.3c-1,0.9-1.9,1.7-2.9,2.6c-0.1,0.1-0.1,0.1-0.1,0.3c-0.1,2.7-0.1,5.5-0.2,8.2c0,0.2,0,0.2,0.2,0.2 c2,0,3.9,0.1,5.9,0.2c0.3,0,0.7,0,1,0.1c0.1,0,0.1,0,0.1,0.1c0,0.8,0,1.6,0,2.3c0,0.1-0.1,0.2-0.2,0.2c0,0-0.1,0-0.1,0 c-7.3,0-14.6,0-21.9,0c-0.3,0-0.2,0-0.2-0.3c0-0.7,0-1.4,0-2.2c0-0.2,0.1-0.2,0.2-0.2c1.3-0.1,2.5-0.2,3.8-0.3 c1-0.1,2.1-0.2,3.1-0.2c0.2,0,0.1-0.1,0.1-0.2c0-1.6,0-3.2,0-4.8c0-1,0-1.9,0-2.9c0-0.1,0-0.2-0.1-0.3c-2.4-2.9-4.8-5.8-7.2-8.7 c-1.8-2.2-3.6-4.4-5.5-6.6c-0.1-0.1-0.2-0.2-0.3-0.2c-2.1-0.2-4.2-0.3-6.3-0.5c-0.3,0-0.3,0-0.3-0.3c0-0.8,0-1.7,0-2.5 c0-0.2,0.1-0.2,0.2-0.2c7.4,0,14.8,0,22.3,0c0.2,0,0.2,0,0.2,0.2c-0.1,0.9-0.2,1.7-0.2,2.6c0,0.1-0.1,0.2-0.2,0.2 c-1,0.1-2,0.1-3.1,0.2c-1,0.1-1.9,0.2-2.8,0.3c0,0-0.1,0-0.1,0c0.6,0.7,1.2,1.4,1.8,2.2c2.5,3.1,5,6.1,7.4,9.2 c0.2,0.2,0.2,0.2,0.4,0c2.9-2.4,5.7-4.9,8.6-7.3c0.1-0.1,0.2-0.2,0.3-0.3c-0.1,0-0.2,0-0.2,0c-1.7-0.1-3.3-0.1-5-0.2 c-0.6,0-1.1-0.1-1.7-0.1c-0.1,0-0.2-0.1-0.2-0.2c0-0.9,0-1.7,0-2.6c0-0.1,0-0.2,0.2-0.2c0.9,0,1.8,0,2.7-0.1 c4.4-0.1,8.7-0.1,13.1-0.2c0.9,0,1.9,0,2.8,0c0.2,0,0.2,0,0.2,0.2c0,1,0,2.1,0,3.1c0,0.1,0,0.2-0.2,0.2c-1.6,0.1-3.2,0.3-4.8,0.4 C55.6,32.5,55.2,32.5,54.7,32.5z M62.8,52.7C62.8,52.8,62.8,52.8,62.8,52.7c-0.6,0.1-1.1,0.1-1.6,0.1c-0.5,0-1,0-1.5,0 c-0.1,0-0.1,0-0.1-0.1c0-0.5-0.1-0.9-0.1-1.4c0-0.4-0.1-0.9-0.1-1.3c0,0,0,0,0.1,0c0.3,0,0.5,0,0.8,0.1c0.3,0,0.7,0.1,1,0.1 c0.4,0,0.8,0.1,1.2,0.1c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.1,0.1C62.8,51.1,62.8,51.9,62.8,52.7z M65.5,36.1c-0.5,1.9-0.9,3.9-1.4,5.8 c-0.5,2.2-1,4.3-1.6,6.5c0,0.1,0,0.1-0.1,0.1c-0.8-0.1-1.5-0.2-2.3-0.2c-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1-0.1c0-0.3,0-0.5,0-0.8 c0-0.3,0-0.5,0-0.8c0-0.7,0-1.5,0-2.2c0-0.8,0-1.6,0-2.4c0-0.8,0-1.6,0.1-2.4c0-0.8,0-1.6,0-2.4c0-0.6,0-1.1,0-1.7 c0-0.1,0-0.1,0.1-0.1c0.5,0,0.9,0,1.4,0.1c0.3,0,0.6,0,0.9,0c0.6,0,1.1,0.1,1.7,0.1c0.4,0,0.7,0,1.1,0.1c0.1,0,0.2,0,0.3,0 c0,0,0,0,0,0C65.6,35.7,65.5,35.9,65.5,36.1z'
                />
            );

        case 'Zalo':
            return (
                <g>
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M58.1,39.4c-1.8-0.1-3,1.2-3.1,3.2c0,0.8,0.2,1.6,0.6,2.3c0.1,0.2,0.3,0.3,0.4,0.5c1.1,0.9,2.8,0.8,3.8-0.3 c1-1.2,1-3.3,0.1-4.6C59.6,39.9,58.9,39.5,58.1,39.4z'
                    />
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M36.9,39.4c-1.8-0.1-3,1.3-3,3.6c0,0.7,0.3,1.4,0.7,2c0.2,0.2,0.3,0.4,0.5,0.5c1.2,0.9,2.9,0.6,3.7-0.5 c0.9-1.2,0.9-3.3,0-4.5C38.4,39.8,37.7,39.5,36.9,39.4z'
                    />
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M40,5C20.7,5,5,20.7,5,40s15.7,35,35,35s35-15.7,35-35S59.3,5,40,5z M27.9,49.4c-2.6,0-5.3,0-7.9,0 c-0.8,0-1.5,0-2.3,0c-0.9,0-1.9-0.2-2.3-1.2c-0.5-1-0.1-1.9,0.5-2.7c2.5-3.2,5-6.4,7.6-9.6c0.1-0.2,0.3-0.4,0.4-0.6 c-0.2-0.3-0.4-0.1-0.6-0.2c-1.8,0-3.5,0-5.3,0c-0.4,0-0.8,0-1.2-0.1c-0.9-0.2-1.5-1.1-1.3-2.1c0.1-0.6,0.6-1.1,1.3-1.3 c0.4-0.1,0.8-0.1,1.2-0.1c2.9,0,5.8,0,8.7,0c0.5,0,1,0,1.5,0.2c1.1,0.4,1.6,1.4,1.1,2.5c-0.4,0.9-1,1.7-1.6,2.5 c-2.1,2.7-4.3,5.4-6.4,8.1c-0.2,0.2-0.3,0.4-0.6,0.8c2.5,0,4.8,0,7.1,0c1.3,0,2,0.6,2.1,1.6C30.1,48.5,29.3,49.4,27.9,49.4z M43.6,47.6c0,0.8-0.6,1.6-1.4,1.8c-0.8,0.3-1.7,0.1-2.3-0.6c-0.3-0.3-0.4-0.4-0.8-0.1c-1.5,1.2-3.2,1.4-5,0.8 c-2.9-0.9-4.1-3.2-4.4-6c-0.3-3,0.7-5.5,3.3-7.1c2.2-1.3,4.5-1.2,6.5,0.6c0.4-0.5,0.8-1,1.5-1.1c1.3-0.3,2.5,0.6,2.5,1.9 C43.7,41.1,43.7,44.3,43.6,47.6z M49.5,39.9c0,2.5,0,5.1,0,7.6c0,1.2-0.9,2.1-2.1,2.2c-0.2,0-0.4,0-0.6-0.1 c-0.8-0.2-1.4-1.1-1.4-2.1v-13c0-0.8,0-1.5,0-2.3c0-1.3,0.8-2.1,2-2.1c1.2,0,2.1,0.8,2.1,2.1C49.5,34.8,49.5,37.3,49.5,39.9z M58.5,49.8c-4.3,0.4-7.6-2.7-7.6-6.7c-0.1-4.2,2.6-7.3,6.5-7.4c4.2-0.1,7.2,2.7,7.3,6.7C64.9,46.5,62.4,49.4,58.5,49.8z'
                    />
                </g>
            );

        case 'Email':
            return (
                <path
                    {...props}
                    style={{ fill: '#A2AABD' }}
                    d='M40,5C20.7,5,5,20.7,5,40s15.7,35,35,35s35-15.7,35-35S59.3,5,40,5z M63.2,53c0,1.7-1.2,2.9-2.9,2.9 c-6.8,0-13.6,0-20.3,0c-6.7,0-13.4,0-20.1,0c-2.1,0-3.1-1.1-3.2-3.1c-0.1-1.2,0.3-1.9,1.3-2.6c3.9-3.1,7.8-6.2,11.6-9.4 c0.4-0.3,0.7-0.3,1.1-0.1c2.8,1.5,5.6,2.9,8.5,4.4c0.6,0.3,1.1,0.3,1.7,0c2.8-1.5,5.7-2.9,8.5-4.4c0.4-0.2,0.7-0.2,1,0.1 c4.1,3.4,8.3,6.7,12.4,10.1c0.2,0.2,0.4,0.6,0.4,0.9C63.3,52.1,63.2,52.6,63.2,53z M16.8,47.6c0-4.7,0-9.3,0-14 c3.5,1.8,7,3.6,10.6,5.4C23.9,41.9,20.4,44.7,16.8,47.6z M52.5,39c3.6-1.8,7.1-3.6,10.7-5.5c0,4.7,0,9.3,0,14.1 C59.6,44.7,56.1,41.9,52.5,39z M61.7,29.8c-7,3.5-14,7.1-21,10.7c-0.5,0.3-0.9,0.3-1.4,0C32,36.8,24.7,33,17.4,29.3 c-0.5-0.3-0.8-0.6-0.7-1.1c0-0.3,0-0.5,0-0.8c0-2.2,1-3.3,3.2-3.3c6.7,0,13.3,0,20,0c6.7,0,13.4,0,20.1,0c2.1,0,3,1.1,3.2,3.2 C63.4,28.6,62.9,29.2,61.7,29.8z'
                />
            );

        case 'Line':
            return (
                <Fragment>
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M40,5C20.7,5,5,20.7,5,40s15.7,35,35,35s35-15.7,35-35S59.3,5,40,5z M63.3,47.8c-0.1,0.2-0.3,0.4-0.5,0.6l0,0 c-0.9,1.1-1.9,2.1-3,3c-7.6,7-20,15.3-21.6,14c-1.4-1.1,2.4-6.6-2-7.5c-0.3,0-0.6-0.1-0.9-0.1l0,0v0C22.4,56,12.7,47.1,12.7,36.3 c0-12.1,12.2-21.9,27.3-21.9c15.1,0,27.3,9.8,27.3,21.9C67.3,40.5,65.8,44.5,63.3,47.8z'
                    />
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M23.7,46L23.7,46h0.1h5.4c0.8,0,1.4-0.6,1.4-1.4v-0.1c0-0.8-0.6-1.4-1.4-1.4h-4v-9c0-0.8-0.6-1.4-1.4-1.4h-0.1 c-0.8,0-1.4,0.6-1.4,1.4v10.6C22.3,45.4,22.9,46,23.7,46L23.7,46z M57.9,39.4v-0.1c0-0.8-0.6-1.4-1.4-1.4h-4v-2.3h4 c0.8,0,1.4-0.6,1.4-1.4v-0.1c0-0.8-0.6-1.4-1.4-1.4H51h0h-0.1c-0.8,0-1.4,0.6-1.4,1.4v10.6c0,0.8,0.6,1.4,1.4,1.4H51h0h5.4 c0.8,0,1.4-0.6,1.4-1.4v-0.1c0-0.8-0.6-1.4-1.4-1.4h-4v-2.3h4C57.2,40.8,57.9,40.2,57.9,39.4L57.9,39.4z M47.3,45.6L47.3,45.6 c0.3-0.3,0.4-0.6,0.4-1V34c0-0.8-0.6-1.4-1.4-1.4h-0.1c-0.8,0-1.4,0.6-1.4,1.4v6.2l-5.2-6.9c-0.2-0.4-0.7-0.7-1.2-0.7h-0.1 c-0.8,0-1.4,0.6-1.4,1.4v10.6c0,0.8,0.6,1.4,1.4,1.4h0.1c0.8,0,1.4-0.6,1.4-1.4v-6.3l5.2,7.1c0,0,0.1,0.1,0.1,0.1l0,0 c0.1,0.2,0.3,0.3,0.6,0.4c0.2,0.1,0.3,0.1,0.5,0.1h0.1c0.2,0,0.5-0.1,0.7-0.2C47.1,45.8,47.2,45.7,47.3,45.6L47.3,45.6z M33.2,46 h0.1c0.8,0,1.4-0.6,1.4-1.4V34c0-0.8-0.6-1.4-1.4-1.4h-0.1c-0.8,0-1.4,0.6-1.4,1.4v10.6C31.8,45.4,32.4,46,33.2,46z'
                    />
                </Fragment>
            );
        case 'Twitter':
            return (
                <Fragment>
                    <polygon {...props} style={{ fill: '#A2AABD' }} points='24.2310791,22.7525635 50.0299683,57.2474365 55.8721924,57.2474365 30.0733643,22.7525635 	' />
                    <path
                        {...props}
                        style={{ fill: '#A2AABD' }}
                        d='M40,5C20.6700439,5,5,20.6700439,5,40s15.6700439,35,35,35s35-15.6700439,35-35S59.3299561,5,40,5z
		 M48.6514893,60L36.9060669,44.2949219L22.3685303,60h-3.7372437l16.6044312-17.9376221L18.7352295,20h12.7172852
		l10.8174438,14.463623L55.6577759,20h3.7373047L43.9395752,36.6968994L61.3687744,60H48.6514893z'
                    />
                </Fragment>
            );

        case 'register-telegram':
            return (
                <g {...props}>
                    <g>
                        <linearGradient id='register-telegram-SVGID_1_' gradientUnits='userSpaceOnUse' x1='266.88135' y1='0' x2='266.88135' y2='531.81549'>
                            <stop offset='0' style={{ stopColor: '#42BCE8' }} />
                            <stop offset='1' style={{ stopColor: '#23A7DC' }} />
                        </linearGradient>
                        <circle className='st0' cx='266.88107' cy='266.88171' r='266.88129' />
                        <g>
                            <path
                                className='st1'
                                d='M396.74121,153.5215l-47.66702,240.33351c0,0-6.66699,16.66599-25,8.66599L214.0742,318.18701l-40-19.332
			l-67.333-22.668c0,0-10.3335-3.66602-11.3335-11.6655c-1-8,11.6665-12.33401,11.6665-12.33401l267.66699-105
			C374.74121,147.1875,396.74121,137.5215,396.74121,153.5215z'
                            />
                            <path
                                className='st2'
                                d='M205.61909,391.15579c0,0-3.2114-0.30078-7.2114-12.96878c-4-12.66602-24.3335-79.332-24.3335-79.332
			L335.74121,196.1875c0,0,9.33298-5.666,9,0c0,0,1.66699,1-3.33301,5.66701c-5,4.66699-127.0005,114.3325-127.0005,114.3325'
                            />
                            <path className='st3' d='M256.25101,350.52289L212.7412,390.1929c0,0-3.4014,2.57999-7.1221,0.96289l8.3311-73.68558' />
                        </g>
                    </g>
                </g>
            );

        default:
            return <path />;
    }
};

const getStyle = (name) => {
    switch (name) {
        // NOTE: (SVG2JSX) DO NOT DELETE, ADD STYLE.
        case 'register-telegram':
            return `
	 .${name} .st0{fill:url(#register-telegram-SVGID_1_);}
	 .${name} .st1{fill:#FFFFFF;}
	 .${name} .st2{fill:#D2E5F1;}
	 .${name} .st3{fill:#B5CFE4;}
`;
        default:
            return;
    }
};

const SVGContact = ({ name = '', style = {}, fill = '', viewBox = '', width = '100%', className = '', height = '100%' }) => (
    <svg
        width={width}
        style={style}
        height={height}
        className={className}
        xmlns='http://www.w3.org/2000/svg'
        viewBox={viewBox || getViewBox(name)}
        xmlnsXlink='http://www.w3.org/1999/xlink'
    >
        <style dangerouslySetInnerHTML={{ __html: getStyle(name) }}></style>
        {getPath(name, { fill })}
    </svg>
);

export default SVGContact;
